module.exports = __webpack_public_path__ + "static/media/check-mark 1.00997028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/check-mark 1.svg
// module id = 3208
// module chunks = 0